import { render } from "./LeadValidationBlock.vue?vue&type=template&id=21d1a080&scoped=true&ts=true&lang=pug"
import script from "./LeadValidationBlock.vue?vue&type=script&lang=ts"
export * from "./LeadValidationBlock.vue?vue&type=script&lang=ts"

import "./LeadValidationBlock.vue?vue&type=style&index=0&id=21d1a080&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d1a080"]])

export default __exports__